module.exports = __webpack_public_path__ + "static/media/wlan_extra_charge.3f154e87.svg";